<template>
  <div class="statisticalAnalysis">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>

        <el-select v-model="query.provinceId"  filterable placeholder="请选择">
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.examSiteId" @change="tableLoad" filterable placeholder="请选择">
          <el-option label="全部市代" value=""></el-option>
          <el-option v-for="item in examSitList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.year" @change="yearChange" filterable placeholder="请选择">
          <el-option label="全部年份" value=""></el-option>
          <el-option v-for="item in yearList" :key="item.value" :label="item.label+'年'" :value="item.value"></el-option>
        </el-select>
        <el-select
            v-model="query.kspc"
            filterable
            @change="tableLoad" 
          >
          <el-option label="全部批次" value=""></el-option>
            <el-option
              v-for="item in kspcList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        <!-- <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            prefix-icon="el-icon-date"
            @change="dateChange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            :default-time="['00:00:00', '23:59:59']"
            end-placeholder="结束日期"
        >
        </el-date-picker> -->
      </el-col>
      <el-button size="small" @click="exportExcel" type="primary">全表导出</el-button>
    </el-row>
    <el-table :row-style="getRowStyle" :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;" row-key="id" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中" :height="$store.getters.getTableHeight">
      <el-table-column prop="name" fixed="left" align="left" label="考点/报名点名称" min-width="300" />
      <!--遍历 start -->
      <el-table-column :label="item.subName" align="center" v-for="item in tableHead" :key="item.id">
        <el-table-column min-width="120" :prop="'persion'+item.id" align="center" label="报名人数" />
        <el-table-column min-width="120" width="" :prop="'amount'+item.id" align="center" label="金额" />
      </el-table-column>
      <!--遍历 end -->
      <el-table-column label="金额合计" fixed="right" width="520"  align="center">
        <el-table-column fixed="right"  width="120" prop="registerNum" align="center" label="总人数" />
        <el-table-column fixed="right"  width="200"  prop="amount" align="center" label="总金额" />
        <el-table-column fixed="right"  width="200"  prop="salary" align="center" label="考点收入" />
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { exportFile } from "@/uitls/globalFun.js";
export default {
  data() {
    return {
      tableIsLoad: false,
      tableList: [],//列表数据
      proList: [],//省份下拉
      examSitList: [],//考点下拉
      tableHead: [],//表格头数据
      yearList: [],//年份集合
      // year:'',
      kspcList: [
        { value: "1", label: "春季" },
        { value: "2", label: "夏季" },
        { value: "3", label: "秋季" },
        { value: "4", label: "冬季" },
      ],
      query: {
        query: "",
        provinceId: "",
        examSiteId: "",
        year: null,
        // startDate:'',
        // endDate:'',
        kspc:"",
      },
      // dateTime:[],
      isTable:true,
    };
  },
  async mounted() {
    //获取年份数据
    await this.getYearList();
    // await this.tableLoad();
    //获取下拉框数据
    this.getSelectList();
  
   



    // this.isTable = false;
    // this.$nextTick(()=>{
    //   this.isTable = true;
    // })
  },
  methods: {
    // dateChange(val){
    //   console.log(val)
    //   if(val){
    //     this.query.startDate = val[0];
    //     this.query.endDate = val[1];
    //   }
    //   else {
    //     this.query.startDate = '';
    //     this.query.endDate = '';
    //   }
    //   this.tableLoad()
    // },
    //获取年份数据
  //  async getYearList() {
  //     await this.$axios.get("/incomeAnalysis/selectData").then((res) => {
  //       this.yearList = res.data.data;
  //       if (this.yearList && this.yearList.length > 0) {
  //         this.query.year = this.yearList[0].value;
  //         // this.year = this.yearList[0].value;
  //       }
  //       // let date = new Date().toLocaleDateString();
  //       // let startDate =  new Date(date+' 00:00:00').getTime();
  //       // let endDate = new Date(date+' 23:59:59').getTime()+24*60*60*1000;
  //       // this.query.startDate = startDate
  //       // this.query.endDate = endDate
  //       // this.dateTime = [startDate,endDate]
  //     });
  //   },
    async getYearList() {
      try {
        const [yearResponse] = await Promise.all([
          this.$axios.get("/examInformation/selectFilterData"),
        ]);
        // 解构获取当前年度的数据
        this.yearList = yearResponse.data.data;
        if (this.yearList && this.yearList.length > 0) {
          this.query.year = this.yearList[0].value;
          // this.kspcList = this.yearList[0].children
        }
        // 调用列表接口
        await this.tableLoad();

        // 执行接口调用成功后的逻辑
      } catch (error) {
        // 处理错误情况
      }
    },
    // 获取下拉框数据
    getSelectList() {
      this.$axios.get("/incomeAnalysis/newProvince").then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get("/incomeAnalysis/examinationSite").then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
    },
    //获取表格数据
    tableLoad() {
      //初始化数据
      this.tableHead = [];
      this.tableList = [];
      this.tableIsLoad = true;
      this.$axios.post("/incomeAnalysis", this.query).then((res) => {
        let data = res.data.data;
        this.getTableHead(data);
        this.getTableData(data);
        this.tableIsLoad = false;
      });
    },
    //获取表格数据
    getTableData(data) {
      let bodyList = data.children;
      bodyList.forEach(element => {
        let info = {
          id: 'exam' + element.id + Math.round(Math.random() * 10000),
          styleType: 2,
          name: element.name,
          registerNum: element.registerNum,
          amount: element.amount,
          salary:element.salary,
        };
        for (let key in element.subjectInfo) {
          let subject = element.subjectInfo[key];
          info['persion' + key] = subject.PERSON;
          info['amount' + key] = subject.AMOUNT;
        }
        let children = this.getItemChildren(element.children);
        info.children = children;
        this.tableList.push(info);
        setTimeout(()=> {
      console.log('123');
      this.$forceUpdate();
      this.$refs.elTable.doLayout()
    },200);
        console.log(    this.tableList);
      });
    },
    //获取报名点子数据
    getItemChildren(data) {
      let list = [];
      data.forEach(element => {
        let info = {
          id: 'assigns' + element.id + Math.round(Math.random() * 10000),
          styleType: 3,
          name: element.name,
          registerNum: element.registerNum,
          amount: element.amount,
          salary:element.salary,
          children: [],
          hasChildren: false
        };
        element.children.forEach(item => {
          info['persion' + item.subjectId] = item.registerNum;
          info['amount' + item.subjectId] = item.amount;
        });
        list.push(info);
      });
      return list;
    },
    //获取表格头部和头部数据
    getTableHead(data) {
      //获取头数据
      let subjectInfo = data.subjectInfo;
      let headInfo = {
        id: 0,
        styleType: 1,
        name: "总计",
        registerNum: data.registerNum,
        amount: data.amount,
        salary:data.salary,
        children: [],
        hasChildren: false
      };
      for (let key in subjectInfo) {
        let info = subjectInfo[key];
        this.tableHead.push({
          id: key,
          subName: info.SUBNAME,
        })
        headInfo['persion' + key] = info.PERSON;
        headInfo['amount' + key] = info.AMOUNT;
      }
      console.log('headInfo',headInfo);
      this.tableList.push(headInfo);
    },
    //获取行样式
    getRowStyle(row, rowIndex) {
      if (row.row.styleType === 1) {
        return {
          color: 'rgb(64, 158, 255)',
          fontWeight: 'bold'
        }
      } else if (row.row.styleType === 2) {
        return {
          fontWeight: 'bold'
        }
      }
    },
    //省份切换
    // proChange(val) {
    //   this.query.examSiteId = "";
    //   if (val == "") {
    //     this.examSitList = [];
    //   } else {
    //     let proObj = this.proList.find((item) => {
    //       return item.provinceId === val;
    //     });
    //     this.examSitList = proObj.examSiteVOS;
    //   }
    //   this.tableLoad();
    // },
    //导出
    exportExcel() {
      this.$axios.post("/incomeAnalysis/export", this.query, { responseType: "blob" }).then((res) => {
        exportFile(res);
      });
    },
    yearChange(val){
      // this.kspcList=[]
      // console.log(val);
      // this.yearList .map((item)=>{
      //   if(item.value===val){
      //     this.kspcList=item.children
      //   }
      // })
      // this.query.year = val===''?null:val;
      this.tableLoad()
    }
  },
};
</script>
<style lang="scss" scoped>
.statisticalAnalysis {
  .tableHearInputBox {
    .el-select {
      width: 140px;
      margin-right: 10px;
    }
  }
}
</style>
<style lang="scss">
.el-table__expand-icon {
  padding-top: 5px !important;
}
.el-table thead.is-group th{
  border:1px solid #e4e4e4;
}
</style>
